export const AnyMediaTypes = ['*/*'] as const;

export const ArchiveMediaTypes = [
  'application/gzip',
  'application/java-archive',
  'application/octet-stream',
  'application/vnd.android.package-archive',
  'application/vnd.ms-cab-compressed',
  'application/x-7z-compressed',
  'application/x-ace-compressed',
  'application/x-alz-compressed',
  'application/x-apple-diskimage',
  'application/x-archive',
  'application/x-arj',
  'application/x-astrotite-afa',
  'application/x-b1',
  'application/x-bzip',
  'application/x-bzip2',
  'application/x-cfs-compressed',
  'application/x-compress',
  'application/x-compressed',
  'application/x-cpio',
  'application/x-dar',
  'application/x-dgc-compressed',
  'application/x-freearc',
  'application/x-gca-compressed',
  'application/x-gtar',
  'application/x-iso9660-image',
  'application/x-lzh',
  'application/x-lzip',
  'application/x-lzma',
  'application/x-lzop',
  'application/x-lzx',
  'application/x-ms-wim',
  'application/x-rar-compressed',
  'application/x-sbx',
  'application/x-shar',
  'application/x-snappy-framed',
  'application/x-stuffit',
  'application/x-stuffitx',
  'application/x-tar',
  'application/x-xar',
  'application/x-xz',
  'application/x-zip-compressed',
  'application/x-zoo',
  'application/zip',
  'application/zstd',
  'multipart/x-zip',
] as const;

export const AudioMediaTypes = ['audio/*'] as const;

export const CsvMediaTypes = ['text/csv'] as const;

export const ImageMediaTypes = ['image/*'] as const;

// @see https://tools.ietf.org/html/rfc2483#section-5 for 'text/uri-list'
export const LinkMediaTypes = ['text/uri-list'] as const;

export const OfferTableMediaTypes = ['text/x-wai-offer'] as const;

export const PdfMediaTypes = ['application/pdf'] as const;

export const PresentationMediaTypes = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.apple.keynote',
] as const;

export const RichTextMediaTypes = ['text/html'] as const;

export const SpreadsheetMediaTypes = [
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.apple.numbers',
] as const;

export const VideoMediaTypes = ['video/*'] as const;

export const WordDocumentMediaTypes = [
  'application/msword',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.oasis.opendocument.text',
  'application/x-abiword',
  'application/vnd.apple.pages',
] as const;

export const JsonMediaTypes = ['application/json'] as const;

export type MediaType =
  | (typeof ArchiveMediaTypes)[number]
  | (typeof AudioMediaTypes)[number]
  | (typeof CsvMediaTypes)[number]
  | (typeof ImageMediaTypes)[number]
  | (typeof LinkMediaTypes)[number]
  | (typeof OfferTableMediaTypes)[number]
  | (typeof PdfMediaTypes)[number]
  | (typeof PresentationMediaTypes)[number]
  | (typeof RichTextMediaTypes)[number]
  | (typeof SpreadsheetMediaTypes)[number]
  | (typeof AnyMediaTypes)[number]
  | (typeof VideoMediaTypes)[number]
  | (typeof WordDocumentMediaTypes)[number]
  | (typeof JsonMediaTypes)[number];
